import { Link } from "react-router-dom";
import { ArrowRight, ClipboardCheck, Lightbulb, Sparkles, UsersRound } from "lucide-react";

const useCases = [
  {
    icon: ClipboardCheck,
    title: "Product managers",
    description: "Turn a feature brief into a handoff that survives the first engineering questions.",
    moment: "When the story is accepted, but the behaviour is not actually decided.",
    href: "/for/product-managers",
  },
  {
    icon: Lightbulb,
    title: "Startups",
    description: "Move quickly while exposing the assumptions most likely to become rebuilds.",
    moment: "When one fast feature contains three expensive guesses.",
    href: "/for/startups",
  },
  {
    icon: UsersRound,
    title: "Product + engineering",
    description: "Keep product context, risks and accepted decisions visible before a sprint begins.",
    moment: "When the rule exists, but never made it into the ticket.",
    href: "/for/product-engineering-teams",
  },
];

export function UseCaseCards() {
  return (
    <section className="relative overflow-hidden py-14 md:py-20">
      <div className="absolute bottom-[20%] right-[10%] h-[400px] w-[400px] rounded-full bg-primary/[0.03] blur-[140px]" />
      <div className="container relative z-10 px-4 md:px-6">
        <div className="mx-auto mb-10 max-w-2xl text-center">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-primary/10 px-3 py-1 text-xs font-medium text-primary">
            <Sparkles className="h-3.5 w-3.5" />
            Built for the moment before build
          </div>
          <h2 className="mb-3 font-sans text-2xl font-bold md:text-3xl">Different teams. The same expensive gap.</h2>
          <p className="text-base text-muted-foreground">
            Requirements appear ready until someone has to choose what the product should actually do.
          </p>
        </div>

        <div className="grid gap-4 lg:grid-cols-3">
          {useCases.map((useCase) => (
            <Link
              key={useCase.title}
              to={useCase.href}
              className="group relative rounded-2xl border border-border/35 bg-card/45 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary/25 hover:shadow-[0_20px_45px_-32px_hsl(var(--primary)/0.45)]"
            >
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-b from-primary/[0.035] to-transparent opacity-0 transition-opacity group-hover:opacity-100" />
              <div className="relative z-10">
                <div className="mb-5 flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10">
                  <useCase.icon className="h-5 w-5 text-primary" />
                </div>
                <h3 className="text-lg font-semibold">{useCase.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{useCase.description}</p>
                <div className="mt-5 rounded-xl border border-border/40 bg-background/55 p-3 text-xs italic leading-relaxed text-muted-foreground">
                  “{useCase.moment}”
                </div>
                <p className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-primary">
                  See how Reqqy helps <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
